import React, { useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { connect } from "react-redux";
import TradeHistoryTab from "./TradeHistoryTab";

const GridBotDealTradeHistory = ((props)=>{
    const [activeTab, setActiveTab] = useState(0);
    const {tradeItems,deal,t} =props 
    const SellTrades = tradeItems.filter((item)=>{
        return item.side ==t("SELL")
    }).sort((a,b)=>{
      return b.price-a.price
    })
    const BuyTrades = tradeItems.filter((item)=>{
        return item.side ==t("BUY")
    }).sort((a,b)=>{
      return b.price-a.price
    })
    
    //const tabItems = [<TradeHistoryTab trades={SellTrades} deal={deal}/>,<TradeHistoryTab trades={BuyTrades} deal={deal}/>];
    return (
      <div className="pd-trade-history-area">
								<div className="pd-th-header-content">
									<div className="row">
										<div className="col-sm-6">
											<div className="pd-th-header-left">
												<h4>Grid Trades</h4>
											</div>
										</div>
										
									</div>
								</div>
      <div className="pd-th-table-area">
									<div className="col-lg-12">
										<div className="pd-th-table-content">
											<div className="open-table-content otc">
												<table className="table">
                            <tr>
                              <th>{t("date")}</th>
                              <th>{t("side")}</th>
                              <th>{t("order-type")}</th>
                              <th>{t("status")}</th>
                              <th>{t("amount")}</th>
                              <th>{t("price")}</th>
                              <th>{t("total-val")}</th>
                            </tr>
                        <tbody>
                          <TradeHistoryTab trades={SellTrades} deal={deal}/>
                          <tr>
                            <td colSpan={7} style={{borderTop:'none',borderBottom:'none'}}><hr></hr></td>
                          </tr>
                          <TradeHistoryTab trades={BuyTrades} deal={deal}/>
                        </tbody>
              </table>
            </div>
          </div>
        </div>
        </div>
        </div>
    )
})
export default connect(null, {
  })(GridBotDealTradeHistory);